// removed by extract-text-webpack-plugin
module.exports = {"mainRow":"pn9kZvE-dEMK0EC9p7fpI"};


//////////////////
// WEBPACK FOOTER
// ./src/views/CreateBillingOrder/Details/styles.css
// module id = 1084
// module chunks = 0